import { RequestedInformation } from '../verification.interface';

export enum IdentitySessionStatus {
    Started = 'STARTED',
    Pending = 'PENDING',
    Completed = 'COMPLETED',
    Failed = 'FAILED',
    Expired = 'EXPIRED',
}

export interface IIdentityResultsResponse {
    sessionStatus: IdentitySessionStatus;
}
export interface IIdentityStatusResponse {
    sessionId: string | null;
    sessionToken: string | null;
    smsRetry: string | null;
    requestedInfo: RequestedInformation[];
    sessionStatus: IdentitySessionStatus | null;
    isAutoIdentityVerificationEnabled: boolean;
    isManualIdentityVerificationEnabled: boolean;
}

export interface IYotiSessionStartResponse {
    sessionId: string | null;
    sessionToken: string | null;
    smsRetry: string;
    sessionStatus: IdentitySessionStatus | null;
    isWaitingOnMobile: boolean;
}
